import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Nav } from "./shared/nav/nav";
import { FooterComponent } from "./shared/footer/footer.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule, Nav, FooterComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('libraries');
      private translate = inject(TranslateService);

    constructor() {
        const savedLang = localStorage.getItem('koha_lang') || 'ar';
        this.translate.addLangs(['ar', 'en']);
        this.translate.setFallbackLang('ar');
        this.translate.use(savedLang);
        document.documentElement.lang = savedLang;
        document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
    }
}
